import styled from "styled-components";
import { theme } from "../theme";

export const StyledForm = styled.form`
	max-width: 33rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	margin-top: 3.6rem;
	button {
		max-width: 20rem;
		width: 100%;
		margin-top: 1.8rem;
	}
	label {
		width: 100%;
	}
	input {
		width: 100%;
	}
	a {
		color: ${theme.color.green};
		align-self: flex-start;
		font-family: ${theme.font.secondary};
		font-weight: 500;
		font-size: 1.2rem;
		margin-top: 1.2rem;
		text-decoration: none;
	}
	p {
		margin-top: 0;
	}
`;
